import listActions from 'src/modules/subscriptionTier/list/subscriptionTierListActions';
import SubscriptionTierService from 'src/modules/subscriptionTier/subscriptionTierService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'SUBSCRIPTIONTIER_DESTROY';

const subscriptionTierDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subscriptionTierDestroyActions.DESTROY_STARTED,
      });

      await SubscriptionTierService.destroyAll([id]);

      dispatch({
        type: subscriptionTierDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.subscriptionTier.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/subscription-tier');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: subscriptionTierDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: subscriptionTierDestroyActions.DESTROY_ALL_STARTED,
      });

      await SubscriptionTierService.destroyAll(ids);

      dispatch({
        type: subscriptionTierDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.subscriptionTier.destroyAll.success'),
      );

      getHistory().push('/subscription-tier');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: subscriptionTierDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default subscriptionTierDestroyActions;
